import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { Box } from '../../Box/Box.js';
import { Typography } from '../../Typography/Typography.js';
import { TypographyStyled } from '../../Typography/Typography.styled.js';
import styled from 'styled-components';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LabelStyled = /*#__PURE__*/styled(Box).withConfig({
  displayName: "FormFieldstyled__LabelStyled",
  componentId: "sc-11x6xcu-0"
})(_defineProperty(_defineProperty({
  transition: 'opacity 0.3s',
  pointerEvents: 'none'
}, "& > ".concat(TypographyStyled), {
  transition: 'color 0.3s'
}), "& > *", {
  transition: 'color 0.3s'
}));
var InputTypographyStyled = /*#__PURE__*/styled(Typography).withConfig({
  displayName: "FormFieldstyled__InputTypographyStyled",
  componentId: "sc-11x6xcu-1"
})({
  width: '100%',
  height: '100%'
});
var resetInputStyles = {
  background: 'transparent',
  outline: 'none',
  appearance: 'none',
  fontWeight: 'inherit',
  fontSize: 'inherit',
  lineHeight: 'inherit',
  fontFamily: 'inherit',
  fontStyle: 'inherit',
  letterSpacing: 'inherit',
  wordSpacing: 'inherit',
  fontStretch: 'inherit',
  fontVariantLigatures: 'inherit',
  fontVariantCaps: 'inherit',
  fontVariantNumeric: 'inherit',
  fontVariantEastAsian: 'inherit'
};
var InputContainerStyled = /*#__PURE__*/styled(Box).withConfig({
  displayName: "FormFieldstyled__InputContainerStyled",
  componentId: "sc-11x6xcu-2"
})(function (props) {
  return _objectSpread(_objectSpread({
    position: 'relative',
    // reset textarea scrollbar styling
    '& textarea': {
      resize: 'none',
      scrollbarColor: 'rgba(0, 0, 0, 0.3) transparent',
      scrollbarWidth: 'thin',
      '&::-webkit-scrollbar': {
        width: '6px',
        backgroundColor: 'transparent'
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '3px',
        backgroundColor: 'rgba(0, 0, 0, 0.3)'
      }
    },
    // reset native input, textarea, select styling
    '& input, & textarea, & select, .ads-button-input': _objectSpread(_objectSpread({}, resetInputStyles), {}, {
      // Fix the safari mobile browser where it sets the disabled field opacity to 0.4 with the user agent
      '&:disabled': {
        opacity: 1
      }
    }),
    '& fieldset': {
      inset: '0',
      transition: 'background 0.3s, border-color 0.3s',
      '& > legend': _objectSpread(_objectSpread({
        height: '25px',
        display: 'flex',
        alignItems: 'center',
        padding: '0',
        pointerEvents: 'none',
        userSelect: 'none',
        maxWidth: '0.01px',
        overflow: 'visible',
        whiteSpace: 'nowrap',
        visibility: 'hidden',
        transition: 'max-width 0.1s'
      }, props.$showLabel && {
        maxWidth: '100%',
        transition: 'max-width 0.3s'
      }), {}, {
        '& > span': _objectSpread({
          opacity: 0,
          visibility: 'visible',
          transition: 'opacity 0.3s, color 0.3s'
        }, props.$showLabel && {
          opacity: 1,
          transition: 'opacity 0.3s, color 0.3s'
        })
      })
    }
  }, props.$showLabel && _defineProperty({}, "& ".concat(LabelStyled), {
    opacity: 0,
    transition: 'opacity 0.3s'
  })), props.$interactiveState);
});
var SkeletonInputContainerStyled = /*#__PURE__*/styled(Box).withConfig({
  displayName: "FormFieldstyled__SkeletonInputContainerStyled",
  componentId: "sc-11x6xcu-3"
})(function (props) {
  return _objectSpread({
    '& input': _objectSpread({}, resetInputStyles)
  }, props.$interactiveState);
});

export { InputContainerStyled, InputTypographyStyled, LabelStyled, SkeletonInputContainerStyled };
//# sourceMappingURL=FormField.styled.js.map
